import { z } from "zod";
import { emailSchema, isoDateSchema, objectIdSchema, userRoleEnum } from "./common";
export const quietHoursSchema = z.object({
    start: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "HH:mm required"),
    end: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "HH:mm required"),
});
/** Persisted shape (server-internal — passwordHash/mfaSecret never leave the API). */
export const userSchema = z.object({
    _id: objectIdSchema,
    email: emailSchema,
    passwordHash: z.string(),
    name: z.string().min(1).max(120),
    emailVerifiedAt: isoDateSchema.nullable(),
    role: userRoleEnum,
    planId: objectIdSchema,
    timezone: z.string().min(1), // IANA tz name, e.g. "Europe/Istanbul"
    quietHours: quietHoursSchema.nullable(),
    mfaSecret: z.string().nullable(),
    mfaRecoveryCodes: z.array(z.string()).default([]),
    createdAt: isoDateSchema,
});
/** Public-facing shape — this is what DTOs/controllers must return, never `userSchema` directly. */
export const userPublicSchema = userSchema.pick({
    _id: true,
    email: true,
    name: true,
    role: true,
    planId: true,
    timezone: true,
    quietHours: true,
    createdAt: true,
}).extend({
    emailVerified: z.boolean(),
    mfaEnabled: z.boolean(),
});
export const registerUserSchema = z.object({
    email: emailSchema,
    password: z.string().min(10).max(128),
    name: z.string().min(1).max(120),
    timezone: z.string().min(1).default("UTC"),
});
export const loginUserSchema = z.object({
    email: emailSchema,
    password: z.string().min(1),
    totpCode: z.string().length(6).optional(),
});
export const updateUserProfileSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    timezone: z.string().min(1).optional(),
    quietHours: quietHoursSchema.nullable().optional(),
});
/** The current password is required so a hijacked session cannot silently lock the owner out. */
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(10).max(128),
});
/** Deleting an account is irreversible, so it re-authenticates rather than trusting the session. */
export const deleteAccountSchema = z.object({
    password: z.string().min(1),
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({
    token: z.string().min(1),
    newPassword: z.string().min(10).max(128),
});
//# sourceMappingURL=user.js.map